// src/model/BishopMoveStrategy.ts
import { MoveStrategy } from './MoveStrategy';
import { Position, BoardState } from '../model/BoardState';

export class BishopMoveStrategy implements MoveStrategy {
  getLegalMoves(position: Position, boardState: BoardState): Position[] {
    const moves: Position[] = [];
    const { row, col } = position;

    // Add diagonal moves
    for (let i = 1; i < 8; i++) {
      const newPosition = { row: row + i, col: col + i };
      if (!this.isWithinBounds(newPosition)) break;
      if (this.isBlocked(newPosition, boardState, position)) break;
      moves.push(newPosition);
      if (this.isOpponentPiece(newPosition, boardState, position)) break;
    }
    for (let i = 1; i < 8; i++) {
      const newPosition = { row: row + i, col: col - i };
      if (!this.isWithinBounds(newPosition)) break;
      if (this.isBlocked(newPosition, boardState, position)) break;
      moves.push(newPosition);
      if (this.isOpponentPiece(newPosition, boardState, position)) break;
    }
    for (let i = 1; i < 8; i++) {
      const newPosition = { row: row - i, col: col + i };
      if (!this.isWithinBounds(newPosition)) break;
      if (this.isBlocked(newPosition, boardState, position)) break;
      moves.push(newPosition);
      if (this.isOpponentPiece(newPosition, boardState, position)) break;
    }
    for (let i = 1; i < 8; i++) {
      const newPosition = { row: row - i, col: col - i };
      if (!this.isWithinBounds(newPosition)) break;
      if (this.isBlocked(newPosition, boardState, position)) break;
      moves.push(newPosition);
      if (this.isOpponentPiece(newPosition, boardState, position)) break;
    }

    return moves;
  }

  getStrategyName(): string {
    return "Bishop Move Strategy";
  }

  /**
   * Checks if the given position is within the bounds of the chess board.
   *
   * @param position - The position to check.
   * @returns `true` if the position is within bounds, `false` otherwise.
   */
  private isWithinBounds(position: Position): boolean {
    return position.row >= 0 && position.row < 8 && position.col >= 0 && position.col < 8;
  }

  private isBlocked(position: Position, boardState: BoardState, currentPosition: Position): boolean {
    const piece = boardState.pieces.find(p => p.position.row === position.row && p.position.col === position.col);
    return piece !== undefined && piece.color === boardState.pieces.find(p => p.position.row === currentPosition.row && p.position.col === currentPosition.col)?.color;
  }

  private isOpponentPiece(position: Position, boardState: BoardState, currentPosition: Position): boolean {
    const piece = boardState.pieces.find(p => p.position.row === position.row && p.position.col === position.col);
    const currentPiece = boardState.pieces.find(p => p.position.row === currentPosition.row && p.position.col === currentPosition.col);
    return piece ? piece.color !== currentPiece?.color : false;
  }
}

